export default __webpack_public_path__ + "static/media/2125.8fb37151.png";